module.exports = __webpack_public_path__ + "img/Layer-4.352e30be.webp";